/* eslint-disable max-len, padded-blocks, prefer-destructuring */

export default {
  computed: {
  },
  methods: {
    onDeleteTOGItmeOkClick() {
      const itemId = this.selectedItem.split('-')[1];
      (async () => {
        this.projectObjectivesLoading = true;

        await this.$store.dispatch('TargetObjectiveGoal/archiveTOG', { cat: this.selectedItemCat, id: itemId });
        this.isRemoveSeleted = false;
        this.isItemToRemoveSelected = false;
        this.projectObjectivesLoading = false;
        this.selectedItem = null;
        this.selectedItemCat = null;
        this.selectedItemName = null;
        this.load();
      })();
    },
    onExportClick() {
      (async () => {
        this.togExportLoading = true;
        await this.$store.dispatch('TargetObjectiveGoal/exportTOG', { projectId: this.projectId, projectName: this.project.projectName });
        this.togExportLoading = false;
      })();
    },
    onAddOkClick() {
      (async () => {
        await this.$store.dispatch('TargetObjectiveGoal/createTOG', {
          cat: this.selectedButton,
          name: this.inpVal.trim(),
          newTargetObjectives: this.selectedNewTargetObjectives,
          newGoalObjectives: this.selectedNewGoalObjectives,
          newObjectiveTargets: this.selectedNewObjectiveTargets,
          newObjectiveGoals: this.selectedNewObjectiveGoals,
          newGoalPriority: this.selectedProjectResourcePriority,
        });
        window.location.href = '/TOGmanagement';
      })();
    },
    onUpdateOkClick() {
      (async () => {
        await this.$store.dispatch('TargetObjectiveGoal/updateTOG', {
          cat: this.selectedButton,
          selectedDropdownItem: this.selectedDropdownItem,
          selectedTargetItems: this.selectedTargetItems,
          selectedObjectiveItems: this.selectedObjectiveItems,
          selectedGoalItems: this.selectedGoalItems,
          selectedProjectResourcePriority: this.selectedProjectResourcePriority,
        });
        this.refreshData();
      })();
    },
  },
};
